import '../scss/loader.scss';

window.addEventListener('beforeunload', function(e) {
	var loadingContainer = document.createElement('div');
	loadingContainer.className = 'loading';
	loadingContainer.innerHTML = '<div class="spinner-border text-dark" role="status"><span class="sr-only">Loading...</span></div>';
	
	document.body.appendChild(loadingContainer);
	
	window.setTimeout(function() {
		loadingContainer.className += ' active';
	}, 200);
	
	window.setTimeout(function() {
		loadingContainer.remove();
	}, 5000);
});